import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import {
  ButtonModule, ControlValueChangesDirective, DIALOG_DATA, DialogRef, IconModule,
  SliderControlComponent,
} from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';

import { DialogData } from './models';

@Component({
  selector: 'pt-interview-viewer',
  imports: [
    ButtonModule,
    IconModule,
    ReactiveFormsModule,
    SliderControlComponent,
    ControlValueChangesDirective,
    TranslateModule,
  ],
  templateUrl: './interview-viewer.component.html',
  styleUrl: './interview-viewer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InterviewViewerComponent {
  private _data = inject<DialogData>(DIALOG_DATA);
  private _dialogRef = inject(DialogRef);

  downloadClicked$ = new Subject<void>();

  imageData = this._data.image;
  showDownloadBtn = this._data.image.showDownloadBtn;
  zoomLevel = signal<number>(1);
  sliderControl = new FormControl<number>(this.zoomLevel() - 1);

  close(): void {
    this._dialogRef.close();
  }

  downloadFile(): void {
    this.downloadClicked$.next();
  }

  onSliderChange(value: number): void {
    this.zoomLevel.set(value + 1);
  }
}
